<template>
  <v-app :theme="theme" :dark="$root.isDark" :style="getBackgroundStyle">
    <AppBar @toggleDrawer="menuDrawer = !menuDrawer" :menu-drawer.sync="menuDrawer" v-if="showNav"></AppBar>

    <v-navigation-drawer v-model="menuDrawer" app temporary right width="280" v-if="showNav">
      <div class="d-flex align-center pa-4">
        <v-img src="@/assets/nukli_logo.png" max-width="26" contain class="mr-2"></v-img>
        <span class="drawer-brand">Nukli</span>
      </div>
      <v-divider></v-divider>
      <v-list nav dense>
        <v-list-item v-for="(item, i) in drawerItems" :key="i" @click="goTo(item)">
          <v-list-item-icon><l-icon>{{ item.icon }}</l-icon></v-list-item-icon>
          <v-list-item-title class="font-weight-medium">{{ item.text }}</v-list-item-title>
        </v-list-item>
      </v-list>
      <div class="pa-4">
        <a class="lp-btn lp-btn--primary drawer-cta" @click="goTo({ route: '/download' })">
          <l-icon small color="white">mdi-download</l-icon>
          {{ $t('nav.getStarted') }}
        </a>
        <a :href="webAppUrl" class="lp-btn lp-btn--ghost drawer-cta mt-2" @click="menuDrawer = false">
          <l-icon small>globe</l-icon>
          {{ $t('nav.openWebApp') }}
        </a>
      </div>
    </v-navigation-drawer>

    <v-main :class="{ 'has-nav': showNav }">
      <v-container fluid class="pa-0" style="max-width: 100% !important;">
        <router-view
          style="width: 100%"
          :style="showNav ? 'min-height: calc(100vh - 64px) !important;' : 'min-height: 100vh !important;'"
        ></router-view>
      </v-container>
    </v-main>

    <Footer v-if="showFooter"></Footer>

    <PricingDialog></PricingDialog>
  </v-app>
</template>

<script>
import AppBar from './components/appbar/AppBar';
import Footer from './views/politiques/Footer';
import PricingDialog from './components/pricing/PricingDialog.vue';
import { WEB_APP_URL } from '@/constants/download';

export default {
  name: 'App',
  components: { AppBar, Footer, PricingDialog },
  metaInfo() {
    return {
      title: this.$t('meta.title'),
      htmlAttrs: { lang: this.$i18n.locale },
    };
  },
  mounted() {
    this.$root.isDark = this.$cookies.get('darkMode') === 'true'
      || (this.$cookies.get('darkMode') == null && this.$vuetify.theme.dark);
    this.$vuetify.theme.dark = this.$root.isDark;
  },
  data() {
    return {
      menuDrawer: false,
      showFooter: true,
      webAppUrl: WEB_APP_URL,
      hideNav: ['SuccessfulSubscription', 'CancelledSubscription', 'Login', 'OAuthCallback'],
    };
  },
  computed: {
    showNav() {
      return !this.hideNav.includes(this.$route.name);
    },
    drawerItems() {
      return [
        { text: this.$t('nav.features'), icon: 'mdi-star-outline', hash: 'features' },
        { text: this.$t('nav.pricing'), icon: 'mdi-tag-outline', hash: 'pricing' },
        { text: this.$t('nav.testimonials'), icon: 'mdi-comment-quote-outline', hash: 'testimonials' },
        { text: this.$t('nav.blog'), icon: 'mdi-newspaper-variant-outline', route: '/blog' },
        { text: this.$t('nav.download'), icon: 'mdi-download', route: '/download' },
      ];
    },
    getBackgroundStyle() {
      return this.$root.isDark ? 'background: #08090a !important' : 'background: #ffffff !important';
    },
    theme() {
      return this.$vuetify.theme.dark ? 'dark' : 'light';
    },
  },
  methods: {
    goTo(item) {
      this.menuDrawer = false;
      if (item.route) {
        this.$router.push(item.route).catch(() => {});
        return;
      }
      const scroll = () => {
        const el = document.getElementById(item.hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      };
      if (this.$route.name !== 'Home') {
        this.$router.push('/').then(() => setTimeout(scroll, 300));
      } else {
        scroll();
      }
    },
  },
  watch: {
    '$i18n.locale'(val) {
      this.$root.currentLanguage = val;
    },
  },
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&display=swap');

/* Sin scroll-behavior: smooth global — animaba el salto a (0,0) al cambiar de
   página. Las anclas de la home ya usan scrollIntoView({behavior:'smooth'}). */

.v-application,
.v-application .text-h1,
.v-application .text-h2,
.v-application .text-h3,
.v-application .text-h4,
.v-application .text-h5,
.v-application .text-h6,
.v-application .text-subtitle-1,
.v-application .text-subtitle-2,
.v-application .text-body-1,
.v-application .text-body-2,
.v-application .text-caption,
.v-application .text-overline {
  font-family: 'Space Grotesk', sans-serif !important;
}

.text-h1, .text-h2, .text-h3, .text-h4 {
  font-family: 'Space Grotesk', sans-serif !important;
  letter-spacing: -0.03em !important;
  font-weight: 600 !important;
}

.v-btn {
  font-family: 'Space Grotesk', sans-serif !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 600 !important;
}

.theme--dark.v-application { background: #08090a; }

.v-main.has-nav { padding-top: 64px; }

.drawer-brand {
  font-weight: 700;
  font-size: 1.2rem;
  background: linear-gradient(135deg, #2c7cff 0%, #6366f1 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.drawer-cta {
  width: 100%;
  height: 46px;
}
</style>
